var Handlebars = require("../../../../../../node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "<tr>\n  <td colspan=\"7\">\n    <div class=\"table-wrapper\">\n"
    + ((stack1 = container.invokePartial(require("./timetable-body-content-hbs.hbs"),depth0,{"name":"./timetable-body-content-hbs.hbs","data":data,"indent":"      ","helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + "    </div>\n  </td>\n</tr>";
},"usePartial":true,"useData":true});